import ContactPage, { handle } from '@modules/professional/page/ContactPage';
import { loader } from '@modules/professional/page/loaders/contact-page-loader.server';

export { loader, handle };
export default ContactPage;
